<template>
    <div class="sub-menu-suspenso">
        <button @click="mostrarMenu=true"> <img src="..\assets\menu-bar.png"></button>
    </div>
    <div class="sub-menu" v-if="mostrarMenu==true">
        <div class="botao-top">
            <router-link to="/"><img src="..\assets\home.png"></router-link>
            <button @click="mostrarMenu=false" class="btn-fechar-menu"><img src="..\assets\close.png"></button>
        </div>
        <div class="wrapper">
            <h1>Minhas Receitas</h1>
            <ul class="botoes">                        
                <li><router-link to="/receitas/cadastro" class="botao" @click="mostrarMenu=false">Consultar</router-link></li>
                <li><router-link to="/receitas/novo/0" class="botao" @click="mostrarMenu=false">Nova Receita</router-link></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  data: () => ({
    mostrarMenu: true
  }),
  created(){
        if (window.screen.availWidth<980)
            this.mostrarMenu = false;
  }
}
</script>

<style>

</style>